import axiosClient from "./axiosClient";

export const eComClaimPointAPI = {
    getList: (params?: string) => {
        const url = "onlineShop/history-claim-point";
        return axiosClient.get(url + params);
    },
    claimPoint: (values: any) => {
        const url = "onlineShop/claim-point";
        return axiosClient.post(url, values);
        // return axiosClientWithNoToken.post(url, values); //! test no token
    },
    getDisplaySetting: () => {
        const url = "merchants/ecommerceDisplaySetting";
        return axiosClient.get(url);
    },
    getOrder: (channel: string) => {
        const url = "onlineShop/history-client-orders/" + channel;
        return axiosClient.get(url);
    },
};
